import type { FC } from 'react';

export interface NumberRangeFilterSummaryProps {
  /** Active filter values as [min, max]; either bound may be absent or empty. */
  values: string[];
}

/**
 * Presentation-only summary of a numeric range filter for the operator tooltip.
 * Renders a labeled row per bound that exists; omits a bound that is empty.
 */
export const NumberRangeFilterSummary: FC<NumberRangeFilterSummaryProps> = ({
  values,
}) => {
  const min = values[0] ?? '';
  const max = values[1] ?? '';
  const hasMin = min !== '';
  const hasMax = max !== '';

  if (!hasMin && !hasMax) {
    return null;
  }

  return (
    <div className="mt-2 flex flex-col gap-1">
      {hasMin && (
        <div className="flex gap-2 text-xs">
          <span className="w-20 shrink-0 text-primary-foreground/70">Min</span>
          <span>{min}</span>
        </div>
      )}
      {hasMax && (
        <div className="flex gap-2 text-xs">
          <span className="w-20 shrink-0 text-primary-foreground/70">Max</span>
          <span>{max}</span>
        </div>
      )}
    </div>
  );
};
